import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import logoCategorias from "./images/logoCategorias.png";
import logoLicencias from "./images/logoLicencias.png";
import minisoLove from "./images/minisoLove1.png";
import "./mioffCanvas.css";
import logoPinguinoOffCanvas from "./imgOffCanvas/pinguinoOffCanvas.png";
import logoMinisoOffCanvas from "./imgOffCanvas/minisoLoveOffCanvas.webp";
import MyTooltip from "./Categories/MyTooltip";
import GenericSubOffCanvas from "./GenericSubOffCanvas/GenericSubOffCanvas";
import { MenuCategories, MenuLicencias } from "./Categories/menuTodas/SubMenus";


const MioffCanvas = ({ showOffCanvas, setShowOffCanvas }) => {
  const [showLicencias, setShowLicencias] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const handleMiOffCanvas = () => {
    setShowOffCanvas((prev) => !prev);
  };
  const handleLicencias =()=>{
    setShowLicencias(prev=>!prev);
  }
  const handleCategories = ()=>{
    setShowCategories(prev=>!prev);
  }
  return (
    <div>
      <Offcanvas
        className="w-75 d-lg-none"
        show={showOffCanvas}
        onHide={handleMiOffCanvas}
      >
        <Offcanvas.Header className="bg-light" closeButton>
          <Offcanvas.Title className="w-50 py-2">
            <div className="d-flex align-items-center justify-content-start w-100">
              <img
                style={{ width: "30px", height: "30px" }}
                src={logoPinguinoOffCanvas}
                alt="logoPinguinoOffCanvas"
              />
              <div className="ms-2 d-flex flex-column align-items-start justify-content-center">
                <p className="fs-6 smaller fw-light ms-1 mb-0">Únete a</p>
                <a href="https://www.miniso.com.mx/minisolove">
                  <img
                    style={{ width: "140px", height: "20px" }}
                    className="mt-0"
                    src={logoMinisoOffCanvas}
                    alt="logoMinisoOffCanvas"
                  />
                </a>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="categoriesOffCanvas text-secondary">
          <ul>
            <li style={{cursor:'pointer'}} onClick={handleCategories}>
              <img className="me-1" src={logoCategorias} alt="logoCategorias" />
              Categorias
            </li>
            {/* <li>
            <MyTooltip titleTooltip={'❤️ San Valentin'} myOffCanvas={true}/>
            </li> */}
            <li>
            <MyTooltip titleTooltip={'Outlet'} myOffCanvas={true}/>
            </li>
            <li>
            <MyTooltip titleTooltip={'Lo Nuevo'} myOffCanvas={true}/>
            </li>
            <li>
            <MyTooltip titleTooltip={'Menos de $79'} myOffCanvas={true}/>
            </li>
            <li>
            <MyTooltip titleTooltip={'Destacados'} myOffCanvas={true}/>
            </li>
            <li style={{cursor:'pointer'}} onClick={handleLicencias}>
              <img src={logoLicencias} alt="logoLicencias" />
              <span className="text-info myOffCanvasHover">Licencias</span>
            </li>
          </ul>
          <hr />
          <ul >
            <li>
              <img src={minisoLove} alt="minisoLove" />
            </li>
            <a style={{ color:'inherit', textDecoration:'none'}} href="https://www.miniso.com.mx/tiendas">
            <li style={{cursor:'pointer'}} className="myOffCanvasHover">Tiendas</li>
            </a>
            <a style={{ color:'inherit', textDecoration:'none'}} href="https://api.whatsapp.com/send?phone=5215580971868">
            <li style={{cursor:'pointer'}} className="myOffCanvasHover">Contactanos</li>
            </a>
            <a style={{ color:'inherit', textDecoration:'none'}} href="https://www.miniso.com.mx/wishlist">
            <li style={{cursor:'pointer'}} className="myOffCanvasHover">Favoritos</li>
            </a>
          </ul>
        </Offcanvas.Body>
        {showLicencias&&<GenericSubOffCanvas showSubOffCanvas={showLicencias} handleCloseSubOffCanvas={handleLicencias} subMenu={MenuLicencias}/>}
        {showCategories&&<GenericSubOffCanvas showSubOffCanvas={showCategories} handleCloseSubOffCanvas={handleCategories} subMenu={MenuCategories}/>}
      </Offcanvas>
      
    </div>
  );
};

export default MioffCanvas;
